import React from "react";
import styles from "./Loader.module.scss";

const Loader = ({ loading = true, fullScreen = true }) => {
  if (!loading) return null;

  return (
    <div className={fullScreen ? styles.backdrop : styles.inlineLoader}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Loader;